<nz-switch
  [nzSize]="size"
  class="color-success"
  [nzDisabled]="disable"
  (ngModelChange)="changeSwitch($event)"
  [nzLoading]="loading"
  [ngModel]="switch">
</nz-switch>